export var HMAPMyVideoInterviewsRoutes = {
    "/recruitment-hub/video-interviews?job_id&job_pos_cat_code&bucket_id&app_id&single&brand_id&hide_images&video_interview&show_reviewer": {
        "name": "appLayout.harriSH.access-portal.video-interviews",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            job_id: {dynamic: true},
            job_pos_cat_code: {dynamic: true},
            bucket_id: {dynamic: true},
            app_id: {dynamic: true},
            brand_id: {dynamic: true},
            single: {dynamic: true},
            hide_images: {dynamic: true},
            show_reviewer: {dynamic: true}
        },
        "component": "hmapMyJobsPage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hmap_my_jobs", "my_applicants", "rejection_templates"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | My Video Screenings"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./my-applicants.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../../modules/hmap/my_jobs/hmap-my-jobs.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../../hmodules/recruitment-hub/recruitment-hub.module.js");
                }
            }
        ]
    }
};